import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { studioApi, STUDIO_TOKEN_KEY } from './studioApi';

const Ctx = createContext({ customer: null, login: async () => {}, register: async () => {}, logout: () => {}, refresh: async () => {} });

export function StudioAuthProvider({ children, onLanguage }) {
  const [customer, setCustomer] = useState(null); // null = checking, false = logged out

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(STUDIO_TOKEN_KEY)) { setCustomer(false); return; }
    try {
      const { data } = await studioApi.get('/auth/me');
      setCustomer(data);
    } catch { setCustomer(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => {
    const h = () => setCustomer(false);
    window.addEventListener('studio-logout', h);
    return () => window.removeEventListener('studio-logout', h);
  }, []);

  const finish = (data) => { localStorage.setItem(STUDIO_TOKEN_KEY, data.access_token); setCustomer(data.customer); return data.customer; };
  const login = async (email, password) => finish((await studioApi.post('/auth/login', { email, password })).data);
  const register = async (payload) => finish((await studioApi.post('/auth/register', payload)).data);
  const logout = () => { localStorage.removeItem(STUDIO_TOKEN_KEY); setCustomer(false); };

  return <Ctx.Provider value={{ customer, login, register, logout, refresh }}>{children}</Ctx.Provider>;
}

export const useStudioAuth = () => useContext(Ctx);
